import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconLahaus from '../build/icon-lahaus'

export const IconLahaus: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconLahaus} />
}

export default IconLahaus
